import { catchError, finalize, map, Observable, of, shareReplay, tap } from "rxjs";
import { Injectable } from "@angular/core";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { BaseService } from "./base.service";
import { getBearerToken, setBearerToken } from "../utils/bearer.token";

@Injectable()
export class AutenticacaoService {

  private _tokenKey = '';
  private _processing = false;
  private _autenticacaoEmAndamento: Observable<string | null> | null = null;

  public set tokenKey(value: string) {
    this._tokenKey = value;
  }

  public get tokenKey() : string {
    return this._tokenKey;
  }

  public get processing() : boolean {
    return this._processing;
  }

  constructor(private readonly baseService: BaseService) {}

  public AutenticarPortal(): Observable<EstruturaRetornoDadosOutputDto<string>> {
    this._processing = true;
    const resultado = this.baseService.post("Autenticacao/Autenticar", {});
    return resultado.pipe(
      tap<EstruturaRetornoDadosOutputDto<string>>( r => {
        setBearerToken(r.dados);
        this.tokenKey = r.dados;
        return r;
      }),
      catchError(() => {
        return of();
      }),
      finalize(() => {
        this._processing = false;
      })
    );
  }

  public ObterTokenAtual(): Observable<string | null> {
    if(getBearerToken()){
      return of(getBearerToken());
    }

    this._autenticacaoEmAndamento ??= this.AutenticarPortal().pipe(
      map(result => {
        return result.dados
      }),
      finalize(() => {
        this._autenticacaoEmAndamento = null;
      }),
      shareReplay(1)
    );

    return this._autenticacaoEmAndamento;
  }
}
